var BROWSERS = {
  MS_EDGE: 'MS Edge',
  EDGE: 'Edge (chromium based)',
  OPERA: 'Opera',
  CHROME: 'Chrome',
  MS_IE: 'MS IE',
  MOZILLA_FIREFOX: 'Mozilla Firefox',
  SAFARI: 'Safari',
  OTHER: 'Other'
};
var PLATFORMS = {
  MAC_OS: 'Mac OS',
  IOS: 'iOS',
  WINDOWS: 'Windows',
  ANDROID: 'Android',
  LINUX: 'Linux'
};
var MACOS_PLATFORMS = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
var WINDOWS_PLATFORMS = ['Win32', 'Win64', 'Windows', 'WinCE'];
var IOS_PLATFORMS = ['iPhone', 'iPad', 'iPod'];

var detectBrowserName = () => {
  if (typeof window === 'undefined') return BROWSERS.OTHER;
  var agent = window.navigator.userAgent.toLowerCase();

  switch (true) {
    case agent.indexOf('edge') > -1:
      return BROWSERS.MS_EDGE;

    case agent.indexOf('edg/') > -1:
      return BROWSERS.EDGE;

    case agent.indexOf('opr') > -1 && !!window.opr:
      return BROWSERS.OPERA;

    case agent.indexOf('chrome') > -1 && !!window.chrome:
      return BROWSERS.CHROME;

    case agent.indexOf('trident') > -1:
      return BROWSERS.MS_IE;

    case agent.indexOf('firefox') > -1:
      return BROWSERS.MOZILLA_FIREFOX;

    case agent.indexOf('safari') > -1:
      return BROWSERS.SAFARI;

    default:
      return BROWSERS.OTHER;
  }
};

var detecOs = () => {
  var userAgent = typeof window === 'undefined' ? 'Other' : window.navigator.userAgent;
  var platform = typeof window === 'undefined' ? 'Other' : window.navigator.platform;

  switch (true) {
    case MACOS_PLATFORMS.indexOf(platform) > -1:
      return PLATFORMS.MAC_OS;

    case IOS_PLATFORMS.indexOf(platform) > -1:
      return PLATFORMS.IOS;

    case WINDOWS_PLATFORMS.indexOf(platform) > -1:
      return PLATFORMS.WINDOWS;

    case /Android/.test(userAgent):
      return PLATFORMS.ANDROID;

    case /Linux/.test(platform):
      return PLATFORMS.LINUX;

    default:
      return PLATFORMS.LINUX;
  }
};

export var getDeviceName = () => detectBrowserName() + " / " + detecOs();
//# sourceMappingURL=device.js.map